/* src/app/admin-dashboard/kampanje/kampanje-category-card/kampanje-category-form.component.css */
.mat-dialog-container {
  padding: 20px;
  border-radius: 8px;
  background-color: #f9f9f9;
}
.form-field {
  margin-bottom: 15px;
}
.form-field label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
  color: #555;
}
.form-field input,
.form-field textarea,
.form-field mat-select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  background-color: #fff;
  transition: border-color 0.3s ease;
}
.form-field input:focus,
.form-field textarea:focus,
.form-field mat-select:focus {
  border-color: #007bff;
  outline: none;
}
.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.mat-dialog-actions {
  margin-top: 20px;
}
.mat-dialog-actions button {
  margin-left: 10px;
}
.label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.label-actions {
  font-size: 12px;
  color: #777;
}
.hint {
  font-size: 12px;
  color: #777;
  margin: 4px 0 12px;
}
.muted {
  color: #888;
}
.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}
.chip {
  background: #e8f0fe;
  color: #1a3d7c;
  border-radius: 12px;
  padding: 2px 10px;
  font-size: 12px;
}
.form-error {
  color: #c62828;
  font-size: 12px;
  margin: -8px 0 12px;
}
/*# sourceMappingURL=kampanje-category-form.component.css.map */
